// extracted by mini-css-extract-plugin
module.exports = {"closed":"BalanceBar_closed__2Olkc","opened":"BalanceBar_opened__3Rzr1","balanceBar":"BalanceBar_balanceBar__2jj5Y","icon":"BalanceBar_icon__12KcL"};